import React from 'react';
import UserStore from '../stores/UserStore';
import * as Inovx from '@shared';
var InovxControls = Inovx.Shared.Controls;

declare var InovxLoader: any;

interface UserViewProps {
}

interface UserViewState {
    user: IUser | any;
}

class UserView extends React.Component<UserViewProps, UserViewState> {
    constructor(props: UserViewProps) {
        super(props);

        this.state = {
            user: UserStore.getEditUser()
        }
    }

    render() {
        return (
            <InovxControls.StaticHeaderForm title={InovxLoader.t("users:form.viewUser")}>
                <InovxControls.FormField title={InovxLoader.t("users:common.username")} inputName=''>
                    <span className="user-field-viewonly">{this.state.user.UserName}</span>
                </InovxControls.FormField>
                <InovxControls.FormField title={InovxLoader.t("users:common.firstname")} inputName='FirstName'>
                    <span className="user-field-viewonly">{this.state.user.FirstName}</span>
                </InovxControls.FormField>
                <InovxControls.FormField title={InovxLoader.t("users:common.lastname")} inputName='LastName'>
                    <span className="user-field-viewonly">{this.state.user.LastName}</span>
                </InovxControls.FormField>
                <InovxControls.FormField title={InovxLoader.t("users:form.userStatus")} inputName=''>
                    <span className="user-field-viewonly">{this.state.user.Enabled ? InovxLoader.t("users:common.enabled") : InovxLoader.t("users:common.disabled")}</span>
                </InovxControls.FormField>
            </InovxControls.StaticHeaderForm>
        )
    }
}

export default UserView;
